export const SCOUT_SKU = 'CM006-01DWW'
export const SHIELD_SKU = 'CMOB1'
export const OLYMPUS_SKU = 'CM021-01DWW'
export const OLYMPUS_UK_SKU = 'CM021-01DUK'
export const OLYMPUS_GIFT_SKU = 'CM021-01DWW-INC'
export const OUTDOOR_CAM_SKUS = [SHIELD_SKU, OLYMPUS_SKU, OLYMPUS_UK_SKU]
export const CABLE_SKU = 'CMCBL1'
export const CABLE_16_INCL_SKU = 'MI037'
export const SIMPLICAM_SKU = 'SSCM2'
export const INTERACTIVE_MONITORING = 'SSEDSM2__4867366'
export const PRO_PREMIUM_MONITORING = 'SSEDSM2_GB__5229044'
export const FAST_PROTECT_THREE_MONTHS_OFFER = 'SSEDSM2__16247908'
export const STANDARD_MONITORING = 'SSSAPP__5475172'
export const ODMON_OVERNIGHT_MONITORING = 'SSODMONON__13798447'
export const ODMON_OVERNIGHT_MONITORING_60 = 'SSODMONON__16723548'
export const ODMON_247_MONITORING = 'SSODMON247__13798553'
export const ODMON_247_MONITORING_60 = 'SSODMON247__16723550'
export const SELF_MONITORING_WITH_CAMERA_RECORDINGS = 'SSSLFCAM__7711192'
export const PRO_PREMIUM_MONITORING_UK = 'SSEDSM2_GB__5229044'
export const PRO_STANDARD_MONITORING_UK = 'SSEDBC1_GB__4293347'
export const PRO_INSTALL = 'SSPSH-ON'
export const PRO_INSTALL_UK = 'SSPSH-UK'
export const BATTERY_SKUS = ['SSCAM-BAT1']
export const ENTRY_SENSOR_SKU = 'SSES3'
export const MOTION_SENSOR_SKU = 'CA001-01DWW'
export const VIDEO_DOORBELL_PRO_SKU = 'SSDB3'
export const ODMON_PREBUILT_PACKAGES = [
  'beacon-en-US',
  'lighthouse-en-US',
  'ss3-11-pieces-outdoors-kit-certified-refurbished-en-US',
  'ss3-16-pieces-outdoors-kit-certified-refurbished-en-US'
]
export const BRAUN_WHITE_SKU = 'CA010-01DUS'
export const BRAUN_BLACK_SKU = 'CA010-02DUS'

export const BRAUN_SKUS = [BRAUN_BLACK_SKU, BRAUN_WHITE_SKU]
export const SKUS_WITH_CART_MAXES = [
  SCOUT_SKU,
  OLYMPUS_SKU,
  OLYMPUS_UK_SKU,
  SIMPLICAM_SKU,
  BRAUN_WHITE_SKU
]

export const ONE_HUNDRED_VISA_GIFT_CARD = 'GCDVP-INC'
export const TWO_HUNDRED_VISA_GIFT_CARD = 'GCVD2-INC'
export const VISA_GIFT_CARDS = [
  ONE_HUNDRED_VISA_GIFT_CARD,
  TWO_HUNDRED_VISA_GIFT_CARD
]
export const VISA_GIFT_CARDS_SET = new Set(VISA_GIFT_CARDS)

export const FIFTY_AMAZON_GIFT_CARD = 'GCDVP-50UK-INC'
export const ONE_HUNDRED_AMAZON_GIFT_CARD = 'GCDVP-100UK-INC'
export const AMAZON_GIFT_CARDS = [
  FIFTY_AMAZON_GIFT_CARD,
  ONE_HUNDRED_AMAZON_GIFT_CARD
]

export const GIFT_CARDS_SET = new Set([
  ...VISA_GIFT_CARDS,
  ...AMAZON_GIFT_CARDS
])

export const PRO_PLAN_SKUS: readonly string[] = [
  ODMON_247_MONITORING,
  ODMON_247_MONITORING_60,
  ODMON_OVERNIGHT_MONITORING,
  ODMON_OVERNIGHT_MONITORING_60
]

export const BASE_STATION = 'SSBS3W'
export const KEYPAD = 'SSKP3W'
export const YARD_SIGN = 'SSYS3'
export const WINDOW_DECALS = 'MI023'

export const CUSTOM_HOME_SECURITY_SYSTEM_SKU_US =
  'simplisafe-custom-home-security-system-en-US'
export const CUSTOM_HOME_SECURITY_SYSTEM_SKU_GB =
  'simplisafe-custom-home-security-system-en-GB'

export const SMB_STANDARD_SKU = 'SSSAPP-SMB__18993924'
export const SMB_CORE_SKU = 'SSEDSM2-SMB__18994653'
export const SMB_PRO_SKU = 'SSODMONON-SMB__18994692'
export const SMB_PRO_PLUS_SKU = 'SSODMON247-SMB__18994702'
export const BUSINESS_PLAN_SKUS: readonly string[] = [
  SMB_STANDARD_SKU,
  SMB_CORE_SKU,
  SMB_PRO_SKU,
  SMB_PRO_PLUS_SKU
]
